
$(document).ready(function () {
 
  

   var officinaNewsPopup = getCookie("officina-newsletter-popup");
  
   if(officinaNewsPopup != '1'){
      setTimeout( function() {
        $('#newsletterModal').show();
      },5000);   

      setCookie("officina-newsletter-popup", "1", 30);
    }
        
  
  $( '.open-popup-newsletter' ).bind('click', function (event) {
            $ ('#newsletterModal').show();
  });


  $( '.close-popup-newsletter' ).bind('click', function (event) {
            $ ('#newsletterModal').hide();
  });
  
  


  var $form = $('#mc-embedded-subscribe-form')
  if ($form.length > 0) {

    $('#mc-subscribe-female').bind('click', function (event) {
      if (event) { event.preventDefault();
            $('#mce-gender').val("Female"); 
            console.log($form.serialize());
            registerJAKNewsletter($form);
      }
    })

    $('#mc-subscribe-male').bind('click', function (event) {
      if (event) { event.preventDefault();
            $('#mce-gender').val("Male"); 
            console.log($form.serialize());
            registerJAKNewsletter($form);  
      }
    })

  }
  
  var $form_footer = $('#mc-embedded-subscribe-form-footer')
  if ($form_footer.length > 0) {

    $('#mc-subscribe-female-footer').bind('click', function (event) {
      if (event) { event.preventDefault();
            $('#mce-gender-footer').val("Female"); 
            console.log($form.serialize());
            registerJAKNewsletterFooter($form_footer);
      }
    })

    $('#mc-subscribe-male-footer').bind('click', function (event) {
      if (event) { event.preventDefault();
            $('#mce-gender-footer').val("Male"); 
            console.log($form.serialize());
            registerJAKNewsletterFooter($form_footer);  
      }
    })

  }
  
  
})

function registerJAKNewsletter($form) {
  $('#mc-embedded-subscribe').val('Sending...');
  $.ajax({
    type: $form.attr('method'),
    url: $form.attr('action'),
    data: $form.serialize(),
    cache: false,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
    success: function (data) {
      $('#mc-embedded-subscribe').val('subscribe')
      if (data.result === 'success') {
        // Yeahhhh Success
        $('#newsletter-modal-body').html('<p class="news-popup-title">Thank you!</p><p style="line-height:1.5;">We will keep you posted about exciting news and new releases.</p>')

      } else {
        // Something went wrong, do something to notify the user.
        $('#mce-EMAIL').css('borderColor', '#ff8282')
        $('#newsletter-popup-subscribe-result').html('<p>' + data.msg.substring(0) + '</p>')
      }
    }
  })
};



function registerJAKNewsletterFooter($form) {
  $('#mc-embedded-subscribe-footer').val('Sending...');
  $.ajax({
    type: $form.attr('method'),
    url: $form.attr('action'),
    data: $form.serialize(),
    cache: false,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
    success: function (data) {
      $('#mc-embedded-subscribe-footer').val('subscribe')
      if (data.result === 'success') {
        // Yeahhhh Success
        $('#newsletter-modal-body-footer').html('<p class="news-popup-title">Thank you!</p><p style="line-height:1.5;">We will keep you posted about exciting news and new releases.</p>')

      } else {
        // Something went wrong, do something to notify the user.
        $('#mce-EMAIL-footer').css('borderColor', '#ff8282')
        $('#newsletter-popup-subscribe-result-footer').html('<p>' + data.msg.substring(0) + '</p>')
      }
    }
  })
};